import { graphql } from "gatsby"
import React from "react"

import InfoBox from "@knowit-alma/common/src/components/molecules/InfoBox/InfoBox"

const InfoBoxBlock = ({ blockDataInfoBox }) => {
  const { heading, list } = blockDataInfoBox || {}
  return (
    <InfoBox heading={heading} list={list?.split("\r\n").filter(Boolean)} />
  )
}

export const query = graphql`
  fragment InfoBox on WpBlockAcfInfoBox {
    __typename
    blockDataInfoBox {
      heading
      list
    }
  }
`
export default InfoBoxBlock
